import React, { useState, useEffect } from 'react';
import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';
import { withRouter } from 'react-router-dom';
import FreqStatisticsCrossGraph from './FreqStatisticsCrossGraph';
import queryString from 'query-string';

let initialization = false;
let initParam = {
  type: '03',
  advrtsPrdtCode: '01',
};
const FreqCrossStatistics = ({ displayFilterList, location }) => {
  // 통계보고서 - 어뷰징관리 - 전환율: adverId, eDate, isPop, popGroup, sDate, uri

  // const { t } = useTranslation();
  //const classes = useStyles();

  // 키워드센터 - 광고주별수집현황 : adverId
  const { adverId } = queryString.parse(location.search);
  if (typeof adverId !== 'undefined') initParam.adverId = adverId;

  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);

    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          noneExternalFilter={true}
          displayFilterList={displayFilterList}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <FreqStatisticsCrossGraph params={{ ...params }} />
        </>
      )}
    </>
  );
};

export default withRouter(FreqCrossStatistics);
